import React, { FC, Fragment } from 'react';
import { Route } from 'react-router-dom'
import { PrivateRoute, BrowserRouter } from './routes'
import { routes } from './metadata/routes'
import { connect } from 'react-redux'

import MainLayout from './components/Layout/index'
import PublicLayout from './components/Layout/PublicLayout'
import 'antd/dist/antd.less'
import './styles/global.css'

const RouteComp: FC = () => {
  return (
    <Fragment>
      {
        routes.map((route, index: number) => (
          route.private ? <PrivateRoute key={index} path={route.path} component={route.component} /> :
            <Route exact key={index} path={route.path} component={route.component} />
        ))
      }
    </Fragment>
  )
}

const App: FC = (props: any) => {

  const { logined } = props

  return (
    <BrowserRouter>
      {logined && <MainLayout ><RouteComp /></MainLayout>}
      {!logined && <PublicLayout > <RouteComp /> </PublicLayout>}
    </BrowserRouter>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logined: state.ctx.logined,
  }
}

export default connect(() => mapStateToProps)(App)
